module.exports = __webpack_public_path__ + "static/media/training_material.ac2ae884.svg";